export default {
  "content": "<g clip-path=\"url(#clip0)\" fill=\"#F1EAFF\"><path d=\"M6.614 5.351l.017.035c3.727 7.454 2.018 16.286-3.648 21.513C1.24 28.508.395 31.143 1.49 33.336L4.823 40C18.724 32.611 24.041 14.718 16.7.035L16.682 0 6.614 5.351zM32.614 5.351l.017.035c3.727 7.454 2.017 16.286-3.648 21.513-1.743 1.609-2.588 4.244-1.492 6.437L30.823 40C44.724 32.612 50.041 14.718 42.7.035L42.682 0 32.614 5.351z\"/></g><defs><clipPath id=\"clip0\"><path fill=\"#fff\" d=\"M0 0h48v40H0z\"/></clipPath></defs>",
  "attrs": {
    "width": "48",
    "height": "40",
    "viewBox": "0 0 48 40",
    "fill": "none",
    "xmlns": "http://www.w3.org/2000/svg"
  }
};